/**
 * @prettier
 * @flow
 */
export const PaymentLinkStatuses = Object.freeze({
    ACTIVE: 'ACTIVE',
    PAID: 'PAID',
    CANCELLED: 'CANCELLED',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    PAYMENT_REFUNDED: 'PAYMENT_REFUNDED',
    EXPIRED: 'EXPIRED',
});

export type PaymentLinkStatus = $Values<typeof PaymentLinkStatuses>;
